import { FrameworkContext } from 'global/cnr/contexts/FrameworkContent';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import React, { useContext } from 'react';
import { g_cns } from '../../common/cns';
import { gEnums } from '../../enums/globalEnums';
import { SettingsSolo } from '../../viewSettings/SettingsSolo';
import AppSidebarMenu from './AppSidebarMenu';
import ModalOverlay from 'global/page/ModalOverlay';
import { _longPressDisplayTypes } from 'global/wrappers/LongPressWrapper';

// AppSidebar > AppSidebarMenu > ? SettingsSolo > ViewSettingsSidebar > ViewSettings

/**
 * 
 * @param {*} param0 
 * @returns The contents of the sidebar contained in Sidebar
 * @description contexts must be passed in, not created in the function
 */

const AppSidebar = ({ children }) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { currentSettings_state } = states;

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {};

  const { aps_global, aps_styles } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appSidebarOpen, appSidebarHide, settingsSidebarSoloOpen, soloPermissionType } = framework_state ?? {};
  const { handleShow_appSidebar } = framework_handlers;

  const { settingsOptions } = aps_global ?? {};
  const { useDarkMode } = settingsOptions ?? {};

  const menuSaC = aps_styles ? aps_styles[gEnums.projectStyles.sideMenu] : {};

  let cn = g_cns.app_sidebar_left_wrapper;
  if (useDarkMode) cn += ' settings-dark-mode';
  cn += ' no-sb';
  if (appSidebarHide) cn += ' hdn';

  const sidebarContents = settingsSidebarSoloOpen
    ? <SettingsSolo isGlobal={soloPermissionType === 'appSettings'} />
    : <AppSidebarMenu sac={menuSaC} />;

  const modal = () => <ModalOverlay
    isSidebar={true}
    content={sidebarContents}
    longPressDisplayType={_longPressDisplayTypes.full}
    closeOverlay={() => handleShow_appSidebar(false)}
  />

  return !appSidebarOpen ? children : modal()

};

export default AppSidebar; 